var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('BaseLayout'),_c('v-main',{staticClass:"grey lighten-4"},[_c('v-container',{staticClass:"pa-4"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }